'use client';

import PricingCard from '@/components/PricingPackages/components/PricingCard';
import { usePricingPageContext } from '@/pricing/PricingPageContext';
import * as Pricing from '@/pricing/types';
import { Container } from '@/ui/Section/Container/Container';
import { Section } from '@/ui/Section/Section';

import { BiggerNeeds } from './components/BiggerNeeds';
import { PricingToggle } from './components/PricingToggle';

import styles from './PricingPackages.module.scss';

export function PricingPackages() {
    const { pricingTable, pricingPlanType } = usePricingPageContext();
    const isAgencyPricing = pricingPlanType === Pricing.TableId.AGENCY;

    return (
        <Section primary="inherit" className={styles.section}>
            <Container className={styles.wrapper}>
                <PricingToggle />
                <div className={styles.pricingTable}>
                    {pricingTable.options.map((option) => (
                        <PricingCard
                            key={option.id}
                            display_as_package={option.display_as_package ?? false}
                            action={
                                option.id === 'enterprise' ? 'contact-support' : 'start-a-trial'
                            }
                            isAgencyPlan={isAgencyPricing}
                            option={option}
                            withSeeAllFeaturesLink={!isAgencyPricing}
                        />
                    ))}
                </div>
                {isAgencyPricing && <BiggerNeeds />}
            </Container>
        </Section>
    );
}
